import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

/*
 * Used only in AdminModule
 */
@Injectable({
  providedIn: "root",
})
export class ApiAdminService {
  constructor(private http: HttpClient) {}

  public get<T>(url: string): Observable<T> {
    return this.http.get<T>(url);
  }

  public post<T>(url: string, body?: any): Observable<T> {
    return this.http.post<T>(url, body);
  }

  public put<T>(url: string, body?: any): Observable<T> {
    return this.http.put<T>(url, body);
  }

  public delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url);
  }
}
